import React from 'react';
import AvatarConsultantStyle from './style';
import { useSelector } from 'react-redux';
import { quoteDetailSelector } from 'src/redux/selectors/quoteDetailSelector';

const placeholderAvatar = (
    <div className="placeholder">
        <svg viewBox="0 0 70 70" aria-hidden="true">
            <circle cx="35.1" cy="24.5" r="14.1" />
            <ellipse cx="35.1" cy="64.25" rx="28.7" ry="22.05" />
        </svg>
    </div>
);

const AvatarConsultant: React.FC = () => {
    const { resConsultant } = useSelector(quoteDetailSelector);
    const { image } = resConsultant;

    return (
        <AvatarConsultantStyle>
            {image ? (
                <img alt="" className="avatarImage" src={image} />
            ) : (
                placeholderAvatar
            )}
        </AvatarConsultantStyle>
    );
};

export default AvatarConsultant;
